import { Button } from "shared/Components/button";
import { DetailCard } from "container/MemberDashboard/Components/DetailCard";
import { globalVariables } from "helper/globalVariables";
import { globalClasses } from "helper/globalClasses";
import { Location, Mail, Phone, User, UserSquare } from "helper/images";
import { chevronLeft } from "helper/icons";
import { useMediaQuery } from "react-responsive";
import { OutlineButton } from "shared/Components/outlineButton";
import { TrailTitle } from "./Components/TrailTitle";
import { TrailSubDetail } from "./Components/TrailSubDetail";
import { TrailNotes } from "./Components/TrailNotes";
import moment from "moment";
import { useSelector } from "react-redux";
import { SkipModal } from "container/OnBoarding/RegisterDog/Components/SkipModal";
import { useNavigate } from "react-router-dom";
import { useRef, useState } from "react";
import { PopUpMessages } from "shared/Components/popUpMessages";
import PageInfo from "shared/Components/pageInfo";
import { DEFAULT_DATE_FORMAT } from "helper/utility";
import { orderSearchesElements } from "helper/orderSearchElements";
import { ShareTrialAccess } from "shared/Components/ShareTrialAccess";
const { iconCls } = globalClasses;

const TrialDetail = ({ detail, setDogSignup, isMemberUser }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 1024px)" });
  const { dogsData } = useSelector((state) => state.dogs);
  const { auth } = useSelector((state) => state);
  const [modalTitle, setModalTitle] = useState();
  const [modalDescription, setModalDescription] = useState();

  const user = auth?.authReducer?.user;
  const isOwner = detail?.authId === user?.authId;

  // Debug logging
  console.log("TrialDetail - detail.authId:", detail?.authId, "user.authId:", user?.authId, "isOwner:", isOwner);

  const navigate = useNavigate();
  const modalRef = useRef();
  // Contact details without phone number
  const contactDetails = [
    {
      icon: <UserSquare className={iconCls} />,
      value: detail?.host?.trialSecretaryName,
    },
    {
      icon: <Mail className={iconCls} />,
      value: detail?.host?.trialSecretaryEmail,
    },
  ];
  const handleSignup = () => {
    if (detail?.trail?.status === "Open") {
      if (dogsData?.getMyRegisteredDogs?.length === 0) {
        modalRef.current.openModal();
      } else {
        setDogSignup(true);
      }
    } else {
      if (detail?.trail?.status === "Upcoming") {
        setModalTitle("This Trial is not open for entries");
        setModalDescription(
          "Please come back when the trial opens"
        );
        
        popUpRef.current.openModal();
      } else {
        setModalTitle("This Trial is closed for entries");
        setModalDescription(
          "Entries are no longer being accepted"
        );
        popUpRef.current.openModal();
      }
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };
  
  const popUpRef = useRef();
  
  const ElementList = () => {
    return (
      <div className={`border rounded-lg shadow-100 p-6 md:mr-4 lg:mr-6 sm:mr-2 my-3 md:w-80`}>
        <p className="font-bold text-gray-700 mt-2">Elements Offered:</p>
        <ul>
          {orderSearchesElements(detail?.searches)?.map((search, index) => (
            <li key={index}>
              <i className="fas fa-check-circle text-green-500 mr-2"></i>
              - {search.searchName}
            </li>
          ))}
        </ul>
      </div>
    );
  };
  
  return (
    <>
      {isMobile ? (
        <>
          <div className="mx-6 my-4  flex gap-8  flex-col md:justify-center md:items-center">
            <div className="border rounded-lg shadow-md w-full p-6 mb-4 md:w-[50%]">
                {/* Heading Section - FIRST */}
                <p className="text-gray-900 text-xl font-semibold leading-[30px] font-sans">
                  {moment.utc(detail?.trail?.trialDate).format(
                    "MMM DD, YYYY [–] dddd"
                  )}
                </p>
                <p className="text-gray-900 text-xl font-semibold leading-[30px] font-sans">
                  {detail?.trail?.trialName}
                </p>
                <p className="text-gray-900 text-xl font-semibold leading-[30px] font-sans">
                  {detail?.trail?.trialLocationName}
                </p>
                <p className="text-gray-900 text-xl font-semibold leading-[30px] font-sans">
                  {detail?.trail?.trialLocationAddress}
                </p>
                <p className="text-gray-900 text-xl font-semibold leading-[30px] font-sans">
                  {`${detail?.trail?.city}, ${detail?.trail?.state} ${detail?.trail?.zip || ''}`}
                </p>
                <TrailTitle
                  host={detail?.host?.hostName}
                  level={detail?.searches}
                />
              {isMemberUser && (
                <div className="mt-4 flex gap-2">
                  <OutlineButton
                    label="Back"
                    width="w-1/2"
                    color="text-black"
                    onClick={handleCancel}
                  />
                  <Button
                    onlyDisabled={detail?.trail?.status === "Close" || detail?.trail?.status === "Upcoming"}
                    onClick={handleSignup}
                    label="Enter Trial"
                    width="w-1/2"
                  />
                </div>
              )}
              {/* Trial Details Section */}
              <div className="flex flex-col w-full gap-4 mt-4 pt-4  border-t-[1px] border-gray-300">
                <TrailSubDetail
                  name={detail?.judgeName}
                  time={moment.utc(detail?.trail?.trialDate).format("hh:mm a")}
                  level={detail.searches}
                  fees={10}
                  dogName={"Per Dog"}
                  openDate={moment.utc(detail?.trail?.openDate).format(DEFAULT_DATE_FORMAT)}
                  closeDate={moment.utc(detail?.trail?.closeDate).format(DEFAULT_DATE_FORMAT)}
                  cutoffDate={detail?.trail?.cutoffDate ? moment.utc(detail?.trail?.cutoffDate).format(DEFAULT_DATE_FORMAT) : null}
                  premium={detail?.trail?.trialFile ? "Premium" : "Premium Available Soon"}
                  trialFile={detail?.trail?.trialFile}
                />
              </div>
              <div className="mt-12 pt-4 border-t-[1px] border-gray-300">
                <TrailNotes notes={detail?.trail?.notes} />
              </div>

              <ShareTrialAccess
                trialCalendarId={detail?.id}
                isOwner={isOwner}
                initialSharedUsers={detail?.sharedUsers || []}
              />
            </div>
            {/* Elements Offered and Contact Details - LAST */}
            <div className="w-full h-full md:w-[50%]">
              <ElementList />
              <DetailCard
                label={globalVariables.contactDetails}
                data={contactDetails}
                width="w-full"
              />
            </div>
          </div>
        </>
      ) : (
        <div className={`mx-8 my-8  flex gap-8 `}>
          <div className="border rounded-lg shadow-100 lg:p-6 w-full lg:w-[748px]">
            <div className="flex flex-row justify-between items-start">
              <div>
                <p className="text-gray-900 text-xl font-semibold leading-[30px] font-sans">
                  {moment.utc(detail?.trail?.trialDate).format(
                    "MMM DD, YYYY [–] dddd"
                  )}
                </p>
                <p className="text-gray-900 text-xl font-semibold leading-[30px] font-sans">
                  {detail?.trail?.trialName}
                </p>
                <p className="text-gray-900 text-xl font-semibold leading-[30px] font-sans">
                  {detail?.trail?.trialLocationName}
                </p>
                <p className="text-gray-900 text-xl font-semibold leading-[30px] font-sans">
                  {detail?.trail?.trialLocationAddress}
                </p>
                <p className="text-gray-900 text-xl font-semibold leading-[30px] font-sans">
                  {`${detail?.trail?.city}, ${detail?.trail?.state} ${detail?.trail?.zip || ''}`}
                </p>
              </div>
              {/* <ViewFullDetail /> */}
              {isMemberUser && (
                <div className="flex flex-col items-start justify-start gap-3 ">
                  <OutlineButton
                    label="Back"
                    width="w-[174px]"
                    // color="text-black"
                    // bg="bg-[#FFFFFF80]"
                    onClick={handleCancel}
                  />
                  <Button
                    onlyDisabled={detail?.trail?.status === "Close" || detail?.trail?.status === "Upcoming"} 
                    onClick={handleSignup}
                    label="Enter Trial"
                    width="w-[174px]"
                  />
                </div>
              )}
  
            </div>

            <TrailTitle host={detail?.host?.hostName} />

            <div className="py-4 gap-4  flex justify-between">
              <div className="flex flex-col w-[250px] gap-4">
                <TrailSubDetail
                  name={detail?.judgeName}
                  time={moment.utc(detail?.trail?.trialDate).format("hh:mm a")}
                  level={detail?.searches}
                  fees={10}
                  dogName={"Per Dog"}
                  openDate={moment.utc(detail?.trail?.openDate).format(DEFAULT_DATE_FORMAT)}
                  closeDate={moment.utc(detail?.trail?.closeDate).format(DEFAULT_DATE_FORMAT)}
                  cutoffDate={detail?.trail?.cutoffDate ? moment.utc(detail?.trail?.cutoffDate).format(DEFAULT_DATE_FORMAT) : null}
                  premium={"Premium"}
                  noPremium={"Premium Available Soon"}
                  trialFile={detail?.trail?.trialFile}
                />
              </div>
            </div>
            <div className="mt-8 pt-4 border-t-[1px] border-gray-300">
              <TrailNotes notes={detail?.trail?.notes} />
            </div>

            <ShareTrialAccess
              trialCalendarId={detail?.id}
              isOwner={isOwner}
              initialSharedUsers={detail?.sharedUsers || []}
            />
          </div>

          <div className="w-[324px] h-[330px]">
            <DetailCard
              label={globalVariables.contactDetails}
              showSub={true}
              data={contactDetails}
            />
            <ElementList />
            </div>
        </div>
      )}
      <SkipModal
        ModalHeader={globalVariables.registerDogRequired}
        ModalContent={globalVariables.registerDogSubText}
        ref={modalRef}
        onSkip={() => navigate("/dashboard/registerDog")}
      />
      <PopUpMessages
        ref={popUpRef}
        type="pending"
        title= {modalTitle}
        desc= {modalDescription}
        onCloseModal={() => {
          // Handle close modal logic if needed
        }}
      />
    </>
  );
};

export default TrialDetail;
